webpackJsonp([7243222379581],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tags = function Tags(_ref) {
	  var pathContext = _ref.pathContext,
	      data = _ref.data;
	  var tag = pathContext.tag;
	  var _data$allMarkdownRema = data.allMarkdownRemark,
	      edges = _data$allMarkdownRema.edges,
	      totalCount = _data$allMarkdownRema.totalCount;
	
	  var tagHeader = totalCount + ' post' + (totalCount === 1 ? '' : 's') + ' etiquetados como "' + tag + '"';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'pageContainer static-page' },
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      null,
	      _react2.default.createElement('meta', { name: 'robots', content: 'noindex, follow' }),
	      _react2.default.createElement(
	        'title',
	        null,
	        'Etiquetas'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'blog-list-container static-page' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        tagHeader
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        edges.map(function (_ref2) {
	          var node = _ref2.node;
	          var _node$frontmatter = node.frontmatter,
	              path = _node$frontmatter.path,
	              title = _node$frontmatter.title;
	
	          return _react2.default.createElement(
	            'li',
	            { key: path },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: path },
	              title
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'tag', to: '/etiquetas' },
	        'Ver todas las etiquetas'
	      )
	    )
	  );
	};
	
	// Components
	
	
	Tags.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    tag: _propTypes2.default.string.isRequired
	  }),
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      totalCount: _propTypes2.default.number.isRequired,
	      edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        node: _propTypes2.default.shape({
	          frontmatter: _propTypes2.default.shape({
	            path: _propTypes2.default.string.isRequired,
	            title: _propTypes2.default.string.isRequired
	          })
	        })
	      }).isRequired)
	    })
	  })
	};
	
	exports.default = Tags;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tag-template-js-16149d9c435148ce0b6a.js